import React from 'react';
import Header from './HeaderHome';
import Footer from './FooterHome';

const Overview = () => {
  // ── Service data ──
  const services = [
    {
      icon: "👵",
      title: "Care for Senior Citizens",
      desc: "Providing assistance, essential supplies, emotional support, and healthcare aid to elderly people who need love and care.",
    },
    {
      icon: "👧",
      title: "Child Welfare",
      desc: "Supporting underprivileged children through educational assistance, nutrition, school supplies, and opportunities for a brighter future.",
    },
    {
      icon: "♿",
      title: "Support for Persons with Disabilities",
      desc: "Extending financial and material assistance, mobility aids, and rehabilitation support to differently-abled individuals.",
    },
    {
      icon: "🏥",
      title: "Health & Medical Assistance",
      desc: "Helping economically disadvantaged patients with medical treatment, medicines, health camps, blood donation drives, and emergency healthcare support.",
    },
    {
      icon: "🎓",
      title: "Education for Poor Students",
      desc: "Providing scholarships, school bags, books, uniforms, stationery, and other educational necessities to deserving students.",
    },
    {
      icon: "🌳",
      title: "Environment & Nature Conservation",
      desc: "Promoting a greener tomorrow through tree plantation drives, environmental awareness programmes, and nature preservation initiatives.",
    },
    {
      icon: "🤝",
      title: "Community Service",
      desc: "Organising relief activities, social welfare programmes, awareness campaigns, and humanitarian initiatives to uplift communities.",
    },
  ];

  return (
    <>
      <Header />

      {/* ========== OVERVIEW HERO ========== */}
      {/* <section className="overview-hero relative text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center py-24 md:py-32">
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-4">About Us</h1>
            <p className="text-xl md:text-2xl text-yellow-100/90 font-light">
              Serving humanity with compassion, dignity, and hope
            </p>
            <div className="w-24 h-1 bg-yellow-300 mx-auto mt-6 rounded-full"></div>
          </div>
        </div>
      </section> */}
      <section className="senior-hero relative text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <div className="max-w-3xl mx-auto">

            <h1 className="text-4xl md:text-6xl font-bold leading-tight mb-4">
              About Us
            </h1>
            <p className="text-xl md:text-2xl text-yellow-100/90 font-light">
              Serving humanity with compassion, dignity, and hope
            </p>
            <div className="w-24 h-1 bg-yellow-300 mx-auto mt-6 rounded-full"></div>
          </div>
        </div>
      </section>

      {/* ========== OVERVIEW / ABOUT ========== */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl p-8 md:p-12">
            <div className="text-center mb-10">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800">About Venkatadri Seva Trust</h2>
              <div className="w-20 h-1 bg-primary mx-auto mt-3 rounded-full"></div>
            </div>
            <p className="text-gray-700 text-lg leading-relaxed mb-6">
              Venkatadri Seva Trust is a non-profit charitable organization dedicated to bringing hope, dignity,
              and happiness to the lives of the underprivileged. Inspired by the timeless values of compassion and
              selfless service, the Trust reaches out to those in need, regardless of caste, creed, or religion.
            </p>
            <p className="text-gray-700 text-lg leading-relaxed">
              With a deep-rooted commitment to serving humanity, the Trust works tirelessly across multiple areas
              — from caring for senior citizens and supporting children's education, to providing healthcare
              assistance, disability support, environmental conservation, and community upliftment. Every
              initiative is driven by the belief that service to humanity is service to the Divine.
            </p>
          </div>
        </div>
      </section>

      {/* ========== VISION & MISSION ========== */}
      <section className="py-16 bg-primary">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            {/* Vision */}
            <div className="vision-card rounded-2xl p-8 text-white text-center">
              <div className="text-5xl mb-4">👁️</div>
              <h3 className="text-2xl font-bold mb-3">Our Vision</h3>
              <p className="text-yellow-50/90 text-lg leading-relaxed">
                To build a compassionate and self-reliant society where every individual has access to
                education, healthcare, dignity, and opportunities for a better life.
              </p>
            </div>
            {/* Mission */}
            <div className="vision-card rounded-2xl p-8 text-white text-center">
              <div className="text-5xl mb-4">🎯</div>
              <h3 className="text-2xl font-bold mb-3">Our Mission</h3>
              <p className="text-yellow-50/90 text-lg leading-relaxed">
                To serve the needy with sincerity, empower the underprivileged, protect nature, and create
                lasting social impact through dedicated service and community participation.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ========== AREAS OF SERVICE ========== */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-white">Our Areas of Service</h2>
            <p className="text-yellow-100 mt-2 text-lg">Reaching out with love, dignity, and hope</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
            {services.map((service, idx) => {
              // Center the 7th item on large screens
              const isLast = idx === services.length - 1;
              return (
                <div
                  key={idx}
                  className={`service-card bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-smooth text-center border-t-4 border-primary ${isLast ? 'lg:col-start-2' : ''}`}
                >
                  <div className="service-icon">
                    <span>{service.icon}</span>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-800">{service.title}</h3>
                  <p className="text-gray-600 mt-2 text-sm">{service.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* ========== JOIN OUR MISSION ========== */}
      <section className="py-16 bg-primary">
        <div className="container mx-auto px-4 text-center text-white">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">Join Our Mission</h2>
            <div className="w-20 h-1 bg-yellow-300 mx-auto mb-6 rounded-full"></div>
            <p className="text-xl text-yellow-50/90 italic mb-6">"Every act of kindness creates a ripple of hope."</p>
            <p className="text-lg text-white/80 leading-relaxed mb-8">
              Your generous support—through donations, volunteering, or partnerships—helps us reach more lives and
              build a brighter future for those in need.
            </p>
            <p className="text-xl text-yellow-100 font-light mb-8">
              Together, let us make compassion a way of life and create a better world for generations to come.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <a
                href="/donate"
                className="bg-white text-primary px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-smooth"
              >
                <i className="fas fa-heart mr-2"></i> Donate Now
              </a>
              <a
                href="/volunteer"
                className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white/10 transition-smooth"
              >
                <i className="fas fa-hand-peace mr-2"></i> Volunteer
              </a>

            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Overview;